/**
 * Persist Cook “Preferences: Enabled/Off” across sessions (localStorage, not cookies).
 * Shared so Cook browse, Cookable now, and future consumers stay in sync.
 */

export const COOK_PREFERENCES_ENABLED_KEY = 'cook_preferences_enabled'

/** @returns {boolean} */
export function getCookPreferencesEnabled() {
  if (typeof localStorage === 'undefined') return false
  try {
    const raw = localStorage.getItem(COOK_PREFERENCES_ENABLED_KEY)
    return raw === '1' || raw === 'true'
  } catch {
    return false
  }
}

/** @param {boolean} enabled */
export function setCookPreferencesEnabled(enabled) {
  if (typeof localStorage === 'undefined') return
  try {
    localStorage.setItem(COOK_PREFERENCES_ENABLED_KEY, enabled ? '1' : '0')
  } catch {
    // Ignore quota / private-mode errors.
  }
}
